import React from 'react';
import numberWithSpaces from 'helpers/number-format';
import getCountMax from 'helpers/get-count-max';

import './page-details.scss';

const PageDetails: React.FC<{ count: number; page: number; listingCount: number; }> = ({ count, page, listingCount }) => {
    return (
        <div className="page-details">
            Produkty:&nbsp;
            <span className="page-details--b">
                {numberWithSpaces(((page - 1) * listingCount) + 1)}
                &nbsp;-&nbsp;{numberWithSpaces(Math.min(count, page * listingCount))}
            </span>
            &nbsp;&nbsp;z&nbsp;&nbsp;{getCountMax(count)}
        </div>
    );
};

export default PageDetails;
